module.exports = __webpack_public_path__ + "static/media/techno-6.1e7e968b.png";